Turbo.StreamActions.set_payment_form_client_data = function () {
  const event = new CustomEvent("payment-form:set-client-data", {
    detail: {
      clientData: JSON.parse(this.dataset.clientData),
      returnUrl: this.dataset.returnUrl
    }
  })
  document.dispatchEvent(event)
}
